import { Fragment, useContext, useState } from 'react';
import { Listbox, Transition } from '@headlessui/react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../rootReducer';
import { TTMenu } from '../../../../interfaces/menus';
import { setMenu } from '../../../../features/restaurant/restaurant';
import { isMenuAvailable } from '../../../utils';
import { useNavigate, useParams } from '../../../../navigation';
import { useAppDispatch } from '../../../../store';
import {
  ArrowsUpDownIcon,
  CheckIcon,
  ChevronUpDownIcon,
} from '@heroicons/react/20/solid';
import TrackingContext from '../../../Providers/TrackingContext';

export default function MenuListSelection() {
  const menus = useSelector<RootState, TTMenu[]>(
    state => state.restaurant.current_menus,
  );
  const selectedMenu = useSelector<RootState, TTMenu>(
    state => state.restaurant.menu_in_view,
  );
  const qr_code_menu_ids = useSelector<RootState, { [key: string]: number[] }>(
    state => state.cart.qr_code_menu_ids,
  );
  const { trackFBEvent, trackGAEvent } = useContext(TrackingContext);

  const qr = useSelector<RootState, string>(state => state.cart.qr_code);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  // @ts-ignore
  const { r_id } = useParams();

  return (
    <div className="sm:flex sm:w-full w-52">
      {selectedMenu !== null && menus !== null && (
        <Listbox
          value={selectedMenu}
          onChange={value => {
            if (value.id !== selectedMenu.id) {
              dispatch(setMenu(value));
              trackFBEvent(
                'CatalogClick',
                {
                  content_ids: [`ctlg_${value.id}`],
                  content_type: 'product_group',
                  content_name: [value.name],
                  content_category: value.business_type,
                },
                true,
                [value.restaurant_id],
              );
              trackGAEvent(
                'select_content',
                {
                  content_type: 'catalog',
                  content_id: `ctlg_${value.id}`,
                },
                [value.restaurant_id],
              );
              navigate(`/feed/restaurants/${r_id}/menus/${value.id}/`);
            }
          }}
        >
          {({ open }) => (
            <>
              <div className="relative mt-0 sm:w-full">
                <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left  bg-surface-variant rounded-xl shadow-sm cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-primary/10 focus-visible:ring-offset-primary/10 focus-visible:ring-offset-2 focus-visible:border-primary/10 sm:text-sm">
                  <span className="block truncate font-semibold text-on-surface">
                    {selectedMenu.name}
                  </span>
                  <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                    <ChevronUpDownIcon
                      className="w-5 h-5 text-on-surface"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>
                <Transition
                  show={open}
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options
                    as="div"
                    className="z-10 absolute w-full py-1 mt-1 overflow-y-auto text-sm  bg-surface  rounded-md shadow-lg max-h-60 sm:max-h-72 border border-outline sm:text-sm list-none"
                  >
                    {menus.map((menu, personIdx) => {
                      if (
                        isMenuAvailable(menu.hours ?? []) &&
                        (qr !== null
                          ? qr_code_menu_ids[qr]?.length === 0 ||
                            qr_code_menu_ids[qr]?.includes(menu?.id)
                          : true)
                      ) {
                        return (
                          <Listbox.Option
                            as="div"
                            key={personIdx}
                            className={({ active }) =>
                              `${active ? 'text-primary' : 'text-on-surface'}
                            cursor-default select-none relative border-b border-outline-variant py-2 pl-10 pr-4 `
                            }
                            value={menu}
                          >
                            {({ selected, active }) => (
                              <>
                                <span
                                  className={`${
                                    selected ? 'font-medium' : 'font-normal'
                                  } block truncate`}
                                >
                                  {menu.name}
                                </span>
                                {selected ? (
                                  <span
                                    className={`${
                                      active ? 'text-primary' : 'text-primary'
                                    }
                                absolute inset-y-0 left-0 flex items-center pl-3`}
                                  >
                                    <CheckIcon
                                      className="w-5 h-5"
                                      aria-hidden="true"
                                    />
                                  </span>
                                ) : null}
                              </>
                            )}
                          </Listbox.Option>
                        );
                      }
                    })}
                  </Listbox.Options>
                </Transition>
              </div>
            </>
          )}
        </Listbox>
      )}
    </div>
  );
}
